module.exports = __webpack_public_path__ + "static/img/struct5.f07c5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/struct5.png
// module id = mtXK
// module chunks = 1